const state = () => ({
  activeCoinKey: 'usd',

  coins: {
    'usd': { id: 1,     name: 'usd', isUSDT: true,  image: require("@/Groups/Scanner/private/images/coins/dollar.svg") },
    'btc': { id: 1,     name: 'btc', isUSDT: false, image: require("@/Groups/Scanner/private/images/coins/btc.svg")    },
    'eth': { id: 2,     name: 'eth', isUSDT: false, image: require("@/Groups/Scanner/private/images/coins/eth.svg")    },
    'sol': { id: 19067, name: 'sol', isUSDT: false, image: require("@/Groups/Scanner/private/images/coins/sol.svg")    },
  },
});

const actions = {
  activeGeneralId({ commit, state }, id){
    commit('SET_ACTIVE_ID', id)
  }
};

const mutations = {
  SET_ACTIVE_ID(state, id){ 
    state.activeCoinKey = id;
  }
};

const getters = {
  //Получить данные фильтра по монетам
  generalCoins: (state) => state.coins,
  //Key name выбранной монеты
  getActiveCoinKey: (state) => state.activeCoinKey,
  //Выбранная монета
  getActiveCoin: (state) => state.coins[state.activeCoinKey],
  //ID выбранной монеты
  getActiveCoinID: (state) => state.coins[state.activeCoinKey].id,
  //Выбранный фильтр это USD
  getIsUSD: (state) => state.activeCoinKey == 'usd',
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};